// extracted by mini-css-extract-plugin
module.exports = {"customHeader":"styles--customHeader--24B-L"};